import { render, staticRenderFns } from "./ConfigurationLot.vue?vue&type=template&id=0843f458"
import script from "./ConfigurationLot.vue?vue&type=script&lang=js"
export * from "./ConfigurationLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports